module.exports = __webpack_public_path__ + "img/bg1577.16043bad.png";